import Vue from 'vue';
export const EventBusDRE = new Vue();
